import React, { useState,useEffect } from "react";
import { Link,useNavigate,useParams } from "react-router-dom";
import axios from 'axios';

import { useRecoilState } from "recoil";
import { ParentsMenus } from "../../components/recoil/atoms/Menus";

import HeaderUserTitle from "../components/includes/HeaderUserTitle";
import EditPWDOK from "../components/popups/EditPWDOK";

import "../../css/style.css";

//비밀번호 찾기
const EditPWD = () => {
  let mem_idx = 0;
  const navigate = useNavigate();
  const { backMode } = useParams();
  const [varParentMenus,setParentMenus] = useRecoilState(ParentsMenus);

  if(Number(backMode) === 0) mem_idx = Number(localStorage.getItem("foundIdx"));
  else mem_idx = Number(localStorage.getItem("mem_idx"));

  //입력정보저장객체
  const [varMemberInfo,setMemberInfo] = useState({});
  const [varCheckedMessage,setCheckedMessage] = useState('');

  useEffect(() => {
    const newMemberInfo = {mem_idx:mem_idx,mem_pwd:"",mem_pwd2:"",mem_oldpwd:"",chk_pass:0};
    if(Number(backMode) === 1) newMemberInfo.chk_pass = 1;
    setMemberInfo(newMemberInfo);

    console.log(varParentMenus);
    setParentMenus({showMenu:false,gotoMain:1});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //입력값 처리
  const onChangeInputHandler = (e) => {
    const { name,value } = e.currentTarget;
    if(name === "mem_oldpwd" && varMemberInfo.chk_pass === 1) {
      setMemberInfo({...varMemberInfo,[name]:value,chk_pass:0});
      if(Number(backMode) === 1) {
        setCheckedMessage("");
      }
    } else {
      setMemberInfo({...varMemberInfo,[name]:value});
    }
  }
  //기존비밀번호 확인
  const onCheckPasswordHandler = async(e) => {
    if (varMemberInfo.mem_oldpwd === "") {
      alert('기존의 비밀번호를 먼저 입력하세요.'); return false;
    }
    const sendData = {mem_idx:mem_idx,mem_pwd:varMemberInfo.mem_oldpwd};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/_check_used_password`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      const smess = datas.message;
      if(datas.retvalue === 1) {
        setMemberInfo({...varMemberInfo,chk_pass:1});
      } else {
        setMemberInfo({...varMemberInfo,mem_oldpwd:""});
      }
      setCheckedMessage(smess);
    });
  }


  //비밀번호 재저장
  const onUpdatePWDHandler = async (e) => {
    if(Number(backMode) === 1) {
      if (varMemberInfo.chk_pass === 0) {
        alert('기존의 비밀번호를 먼저 확인하세요.'); return false;
      }
    }
    if (varMemberInfo.mem_pwd === "") {
      alert('비밀번호를 먼저 입력하세요.'); return false;
    } else if (varMemberInfo.mem_pwd2 === "") {
      alert('확인용 비밀번호를 먼저 입력하세요.'); return false;
    } else if (varMemberInfo.mem_pwd !== varMemberInfo.mem_pwd2) {
      alert('비밀번호와 확인용 비밀번호가 일치하지 않습니다.'); return false;
    }
    const sendData = {infos:varMemberInfo};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/_update_password`,sendData).then((res) => {
      const datas = res.data;
      if(datas.retvalue === 1) {
        navigate('/Parents/MyInfo');
      } else {
        alert(datas.message);
      }
    });
  }

  //팝업창
  const [varShowPopupWin,setShowPopupWin] = useState(false);
  const onClosePopupHandler = (e,ino) => {
    setShowPopupWin(false);
    if(ino === 0) return false;
    if(Number(backMode) === 0) {
      localStorage.removeItem("mem_idx");
      localStorage.removeItem("mem_email");
      localStorage.removeItem("mem_mode");
      localStorage.removeItem("mem_name");
      localStorage.removeItem("mem_mobile");
      localStorage.removeItem("mem_nickname");
      localStorage.removeItem("mem_account");
      localStorage.removeItem("userLoginState");
      navigate('/Parents/Login');
    } else {
      navigate('/Parents/MyPage');
    } 
  }
  return (
    <div className="vh-content member-wrap">
      <HeaderUserTitle varPageTitle={'비밀번호 변경하기'} varBackString={Number(backMode)===0?'/Parents/Login':'/Parents/MyInfo'}/>
      <div className="vh-content-body">
        {Number(backMode)===0?null:
          <div className="form-group ms25 mb25 mt25">
            <label className="form-label">기존 비밀번호</label>
            <div className="field-group row-in-button">
              <input type="password" name="mem_oldpwd" value={varMemberInfo.mem_oldpwd||""} placeholder="기존 비밀번호를 입력하세요." className="form-control" onChange={onChangeInputHandler}/>
              <button name="check_pass" className="btn-yes" onClick={e=>onCheckPasswordHandler(e)}>암호 확인</button>
            </div>
            <div className="invalid-tooltip">{varCheckedMessage}</div>
          </div>
        }
        <div className={Number(backMode)===0?"form-group ms25 mb25 mt25":"form-group ms25 mb25"} style={Number(backMode)!==0 && varMemberInfo.chk_pass===0?{display:"none"}:{}}>
          <label className="form-label">비밀번호</label>
          <div className="field-group is-invalid">
            <input type="password" name="mem_pwd" value={varMemberInfo.mem_pwd||""} placeholder="비밀번호를 입력하세요." maxLength={6} className="form-control" onChange={onChangeInputHandler} />
          </div>
          <div className="invalid-tooltip">숫자 6자리로 입력해주세요.</div>
        </div>
        <div className="form-group ms25 mb25" style={Number(backMode)!==0 && varMemberInfo.chk_pass===0?{display:"none"}:{}}>
          <label className="form-label">비밀번호 재확인</label>
          <div className="field-group is-invalid">
            <input type="password" name="mem_pwd2" value={varMemberInfo.mem_pwd2||""} placeholder="비밀번호를 다시 입력하세요." maxLength={6} className="form-control" onChange={onChangeInputHandler} />
          </div>
          <div className="invalid-tooltip">비밀번호와 동일하게 입력해주세요.</div>
        </div>
        <div className="form-contoller bt-btn">
          <Link to={Number(backMode)===0?"/Parents/Login":"/Parents/MyInfo"} className="form-contoller-btn btn-no" style={Number(backMode)!==0 && varMemberInfo.chk_pass===0?{width:"100%"}:{}}>취소</Link>
          <button className="form-contoller-btn btn-yes" style={Number(backMode)!==0 && varMemberInfo.chk_pass===0?{display:"none"}:{}} onClick={e=>onUpdatePWDHandler(e)}>비밀번호 재설정</button>
        </div>
      </div>
      {/* 팝업창 - 비밀번호변경완료  */}
      <EditPWDOK varShowPopupWin={varShowPopupWin} onClosePopupHandler={onClosePopupHandler}/>
    </div>
  );
}
export default EditPWD;